<template>
  <div>
    <Breadcrumb ></Breadcrumb>
    <ak-model-filter-card model="menuDistributionStock" @search="search" @reset="reset" :value="where"/>
    <ak-model-card ref="distributionStock" model="menuDistributionStock" :filters="filters" :page.sync="page" :perPage="20" tableSize="small" />
  </div>
</template>
<script>
import qs from 'qs'
import Breadcrumb from '../../components/tools/Breadcrumb.vue'
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      filters: {
        isDelete: false
      }, // 搜索条件
      page: Number(this.$route.query.page) || 1
    }
  },
  computed: {
    where () {
      let where = { ...this.filters }
      for (let i in where) {
        if (where[i].$regex) {
          where[i] = where[i].$regex
        }
      }
      return where
    }
  },
  watch: {
    page (val) {
      this.reRoute()
      // this.$router.replace({
      //   path: this.$route.path,
      //   query: Object.assign({}, this.$route.query, { page: this.page })
      // })
    }
  },
  mounted () {
    this.filters = {
      ...this.filters,
      ...this.$route.query.filters ? qs.parse(this.$route.query.filters) : {}
    }
  },
  methods: {
    search (filters) {
      this.page = 1
      this.filters = {
        ...filters
      }
      this.reRoute()
    },
    reset () {
      this.page = 1
      this.filters = {
        isDelete: false
      }
      this.reRoute()
    },
    reRoute () {
      let query = {}
      if (Number(this.page) > 1) query.page = this.page
      if (this.filters && Object.keys(this.filters).length > 0) query.filters = qs.stringify(this.filters)
      // if (this.orderBy) query.orderBy = this.orderBy
      // if (this.category) query.category = this.category
      this.$router.push({
        path: this.$route.path,
        query: query
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.amdin_role_card{
  height: 152px;
  color: #152137;
}
</style>
